import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import InputText from "../InputText"
import Calendar from "../../../../../assets/images/habitacional/calendar-picker.svg"

const IncidentDateInput = () => {
    const { control, formState: { errors } } = useFormContext()
    return (
        <Controller
            name="IncidentDate"
            control={control}
            render={({ field }) => (
                <InputText
                    id="IncidentDate"
                    name="IncidentDate"
                    title="Data da ocorrência"
                    placeholder="dd/mm/aaaa"
                    value={field.value}
                    type="date"
                    hasError={errors?.IncidentDate?.message}
                    errorMessage={errors?.IncidentDate?.message}
                    onChange={(e) => field.onChange(e.target.value)}
                    CalendarPicker={Calendar}
                    isRequired
                    {...field}
                />
            )}
        />
    )
}

export default IncidentDateInput